import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Templates</Typography>
      <p>Here you will see a list of your active (or archived -if you toggle the switch position at the top left)
        templates. Templates define the layout and look of the passes you will be issuing. 
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>No templates yet?</Typography>
      <p>You need a template before you can issue a pass. So, click that (+) icon (top left) or, select Create 
        Template from the main menu, or from the dashboard.</p>

      <Typography variant='h5' className='pt-10 pb-5'>What does the table show?</Typography>
      <p>
        Starting from the left:
        <ul>
          <li><b>Menu</b> : Here you will find shortcuts to various actions you can take. Don't worry about those to start with. Explore them 
          when you are more familiar with everything.</li>
          <li><b>Template Group</b> : Our templates are grouped into a few cetagories to make it easier to find a specific one when you have many.</li>
          <li><b>Template ID</b> : This is the unique ID of the template. It's not too important unless you intend to use Smartix API to issue passes.
          If you are then you can copy the ID by clicking on it.</li>
          <li><b>Template Name</b> : This is the name you give to your template when you create it. You can click on this to see more details of your template</li>
          <li><b>Smartix Scanner</b> : A little QR code shows that this template is compatible with Smartix Scan app.</li>
          <li><b>Issued</b> : A counter of the number of passes you have issued. (Excludes test passes)</li>
          <li><b>Active</b> : A counter of the number of passes that have not expired. (Excludes test passes)</li>
          <li><b>Expired</b> : A counter of the number of passes that have expired. (Excludes test passes)</li>
          <li><b>Installed (Apple)</b> : A counter of the number of passes that have been installed on an Apple device (Excludes test passes)</li>
          <li><b>Installed (Google)</b> : A counter of the number of passes that have been installed on a Google Android device (Excludes test passes)</li>
          <li><b>Unsynced</b> : A counter of the number of passes do not refect the current template. See <a href="https://www.smartix.uk/studio/synchronisation/" target='_blank'>synchronisation</a> for more information.</li>
          <li><b>test passes</b> : A counter of the number of test passes you have issued.</li>
          <li><b>Created</b> :  Date and time you created this template</li>
          <li><b>Last Modified</b> :  Date and time you last modified this template</li>
        </ul>
      </p>

      <p>Click colum header for filter and sorting options.</p>

      <Typography variant='h5' className='pt-10 pb-5'>What about those icons?</Typography>
      <p>
        At the top right of the table there are some icons. These allow you to search, filter content, choose which columns to show, toggle the density of
        the rows, view in full screen (press escape key to exit) and download the content of the data. You can download in JSON, CSV or MS Excel formats.
       </p>

      <Typography variant='h5' className='pt-10 pb-5'>What is an archived template?</Typography>
      <p>Active templates are ones you are currently working on or using. You can edit these, issue passes, send notifications to passes etc.</p>
      <p>If you no longer need a template you can archive it, so it's hidden away. When archived you can't edit, or issue passes etc. But you can recover 
        it to your active templates which a simple click.</p>

    </div>
  )
}

export default HelpText